module.exports = __webpack_public_path__ + "static/img/walking-man-green.bccaddc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/walking-man-green.svg
// module id = mRpg
// module chunks = 82